import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';

type LocationCodeInputProps = FieldControllerProps<'locationCode', string | null> & ClassNameProp;

const LOCATION_CODE_MIN_LENGTH = 3;
const LOCATION_CODE_MAX_LENGTH = 4;
const LOCATION_CODE_REGEXP = /^(?!000)[1-9]?\d{3}$/u;

export const LocationCodeInput = (props: LocationCodeInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      minLength: LOCATION_CODE_MIN_LENGTH,
      maxLength: LOCATION_CODE_MAX_LENGTH,
      pattern: {
         value: LOCATION_CODE_REGEXP,
         message: healthcareOrganizationTranslationKeys.locationCodeValidationMessage,
      },
   });

   return (
      <TextInput
         testId={props.name}
         label={healthcareOrganizationTranslationKeys.resortCode.seven}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
